import React from 'react';
import './style.css'

const SelectableItem = (props) => {
	return (
		<div
			className={!props.isDisabled ? "divIconItem" : ''}
			onClick={props.onClick}
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: 80,
				width: props.width ? props.width : 80,
				opacity: props.isSelected ? 1 : 0.3,
				// paddingLeft: 16,
				// paddingRight: 16,
				// paddingTop: 8,
				// paddingBottom: 8,
				border: props.isSelected && "solid 0.5px #0b7e7a",
				borderRadius: 4
			}}
		>
			<img
				src={!props.isDisabled ? props.icon : props.notEnabledIcon}
				width={props.size ? props.size : 35}
				alt={props.label}
			/>
			<label style={{ fontFamily: "sans-serif", fontWeight: "lighter", color: "rgba(0, 0, 0, 0.75)", marginTop: 4, fontSize: 14 }}>{props.label}</label>
		</div>
	);
}

export default SelectableItem